import EventCreator from '@/components/sports/EventCreator';
import Vue from 'vue';

export default Vue.extend({
  name: 'eventCreator',
  render() {
    return <EventCreator />;
  },
});
